import { AbstractControl, ValidatorFn } from '@angular/forms';

/**
 * Stricter email validator that requires a domain with a TLD
 * (e.g. test@test.com). Rejects values like test@test.
 */
export function emailWithDomainValidator(): ValidatorFn {
	return (control: AbstractControl) => {
		const value = control.value;

		if (value == null || value === '') {
			return null;
		}

		// Based on Angular's email regex, but requires at least one dotted domain label (TLD).
		const emailWithDomainRegex =
			/^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

		return emailWithDomainRegex.test(value)
			? null
			: {
					email: {
						message: 'Please enter a valid email address (e.g. name@example.com)'
					}
			  };
	};
}
